import { render, staticRenderFns } from "./DiscountsDetail.vue?vue&type=template&id=6915792e"
import script from "./DiscountsDetail.vue?vue&type=script&lang=js"
export * from "./DiscountsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports